<template>
  <v-container id="HomePage" fluid tag="section">
    <v-app-bar color="#b88611" dense dark>
      <v-toolbar-title>Events / Take outs</v-toolbar-title>
    </v-app-bar>
    <v-spacer />
    <v-row>
      <v-container>

        <v-text-field v-model="search_query" label="Search" outlined @input="searchItems()" />

      </v-container>
    </v-row>
    <v-row class="cols">

      <v-col v-for="(i, index) in items_to_display" :key="index" sm="12" md="6" lg="4">
        <base-material-card color="#455A64" class="px-3 py-10" style="font-size: large; font-weight: 200;"
          :title="i.why">
          <v-card class="mx-auto" max-width="390" color="#aabbaa" elevation="7">
            <v-card-text>
              <p class="display-1 text--primary">
                <b>Event / Venue - </b>{{ i.where }}<br />
                <b>Event ID - </b>{{ i.id }}
              </p>

              <hr />
              <br />
              <v-list-item-subtitle>
                <b>By</b> {{ i.by }}<br />
                <b>On</b> {{ i.date }} <br />
                <b>At</b> {{ i.time }}<br />
                <b>User</b> {{ i.user }}
              </v-list-item-subtitle>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn text outlined large @click="seeMore(i.id)">
                See More
              </v-btn>
            </v-card-actions>
          </v-card>
        </base-material-card>
      </v-col>
    </v-row>
    <v-row>
      <v-dialog v-model="loader" persistent width="200">
        <v-card>
          <v-card-text>
            <v-container>
              <v-row class="justify-center">
                Please Wait...
              </v-row>
              <v-row class="mt-2 justify-center">
                <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import Vue from 'vue';
import VueCookies from 'vue-cookies';
import db from './api/firebaseInit';

Vue.use(VueCookies);

export default {
  data: function () {
    return {
      dataReady: false,
      items: [],
      items_to_display: [],
      loader: true,
      search_query: ''
    };
  },
  mounted() {
    db.collection('orderIDs')
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          // // console.log(doc.data());
          var tempObj = {
            why: doc.data().why,
            where: doc.data().where,
            by: doc.data().by,
            date: doc.data().date,
            time: doc.data().time,
            user: doc.data().user,
            id: doc.id,
          };
          this.items.push(tempObj);
          this.items_to_display.push(tempObj);
        });
        this.loader = false;
      })
      .catch((err) => {
        const error = err;
        // console.log('Error getting documents', error)
      });
  },
  methods: {
    seeMore: function (id) {
      // console.log(id)
      VueCookies.set('seeMore', id);
      this.$router.push('/getItems');
    },
    searchItems() {
      // Convert the query to lowercase for case-insensitive search
      const lowercaseQuery = this.search_query.toLowerCase();
      // Filter the items array based on the search query
      const filteredItems = this.items.filter((item) => {
        // Check if any of the fields in the item object contain the search query
        return Object.values(item).some((value) => {
          // Convert the value to lowercase for case-insensitive search
          const lowercaseValue = value.toString().toLowerCase();
          // Return true if the value contains the search query
          return lowercaseValue.includes(lowercaseQuery);
        });
      });

      // Return the filtered items
      this.items_to_display = filteredItems
      return;
    }
  },
};
</script>
